var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M84.234 78.581C82.22 72.587 74.193 68.835 68.47 66.32c-2.242-.982-8.449-2.648-9.195-5.471-.267-1.017-.231-1.976-.012-2.895a5.596 5.596 0 0 1-1.057.105h-3.729a5.402 5.402 0 0 1-5.396-5.397c0-2.973 2.42-5.39 5.396-5.39h3.729c1.232 0 2.4.417 3.342 1.161a23.997 23.997 0 0 0 3.955-.866c1.631-3.417 2.903-7.503 3.188-11.02 1.217-15.048-8.008-23.852-21.235-22.33-9.617 1.107-15.362 8.278-15.983 17.51-.628 9.41 2.861 16.36 6.567 21.458 1.623 2.229 3.328 3.662 3.066 6.348-.304 3.176-3.7 4.061-6.129 5.037-2.878 1.156-5.978 2.91-7.442 3.721-5.043 2.785-10.578 6.139-11.822 10.727-2.755 10.168 6.549 13.248 14.23 14.67C36.535 94.904 43.968 95 50.082 95c11.059 0 30.945-.443 34.152-8.756.912-2.359.521-6.118 0-7.663z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M60.566 51.143a2.818 2.818 0 0 0-2.358-1.283h-3.729a2.81 2.81 0 1 0 0 5.618h3.729a2.786 2.786 0 0 0 2.479-1.519c5.199-.409 9.721-1.997 12.895-4.342.729.47 1.591.745 2.521.745h.234a4.687 4.687 0 0 0 4.688-4.693v-9.368a4.673 4.673 0 0 0-2.672-4.224C77.665 17.034 65.212 5 50 5S22.333 17.034 21.648 32.077a4.67 4.67 0 0 0-2.674 4.224v9.368a4.687 4.687 0 0 0 4.684 4.693h.237a4.688 4.688 0 0 0 4.687-4.693v-9.368a4.677 4.677 0 0 0-2.608-4.192C26.643 19.434 37.161 9.331 50 9.331c12.834 0 23.357 10.103 24.023 22.778a4.68 4.68 0 0 0-2.605 4.192v9.368c0 .622.121 1.201.334 1.742-2.732 1.955-6.709 3.348-11.186 3.732z",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaller);
export default __webpack_public_path__ + "static/media/icon_caller.13d6d92d7c0099ad808c2ae260785780.svg";
export { ForwardRef as ReactComponent };